import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { BE_URL_2, httpGet } from '../../http';
import { Link } from 'react-router-dom';
import './Egresos.css';
import { Spinner } from 'react-bootstrap';
import { formatDateMin, formatNumber } from '../../misc/index';


const Egresos = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    useEffect(() => {

        console.log(JSON.parse(sessionStorage.getItem('estado')));

        let newEstado = JSON.parse(sessionStorage.getItem('estado'));
        newEstado.proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        console.log(newEstado);
        
        setEstado(newEstado);
        getEgresos(newEstado.proveedor.nit);

    }, []);

    const getEgresos = (tercero) => {
        setEgresos({
            ...egresos,
            loading: true
        });
        const companyId = sessionStorage.getItem('companyId');
        //httpGet('/ProveedoresWS/api/Egresos?emp=' + companyId + '&fechaDesde=20200101&fechaHasta=20301231&tercero=' + tercero).then(
        httpGet(BE_URL_2 + '/api/v1/egresos/nit/' + tercero + "?empresa=" + companyId + "&pagina=0&cant=1000").then(
            resp => {
                setEgresos({
                    ...egresos,
                    data: resp.data,
                    loading: false
                });
            }
        ).catch(
            error => {
                console.log(error);
                setEgresos({
                    ...egresos,
                    loading: false
                });
            }
        );
    }

    const [egresos, setEgresos ] = useState(
        {
            data: [],
            loading: true,
            error: {}
        }
    );

    const generarEgresoDetallePdf = async (e, egreso2) => {
        e.preventDefault();

        console.log(egreso2);
        const companyId = sessionStorage.getItem('companyId');
        const encabezado = await httpGet('/ProveedoresWS/api/Egresos/encabezado?emp=' + companyId + '&co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);
        const retenciones = await httpGet('/ProveedoresWS/api/Egresos/retenciones?emp=' + companyId + '&co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);
        const detalles = await httpGet('/ProveedoresWS/api/Egresos/detalle?emp=' + companyId + '&co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);

        if((encabezado !== null) && (encabezado !== undefined)){
            let egreso = {
                empresa: estado.empresa,
                proveedor: estado.proveedor,
                encabezado: encabezado.data,
                retenciones: retenciones.data,
                detalles: detalles.data
            }

            console.log(egreso);

            props.history.push({ pathname: '/portal/egreso-pdf', state: { egreso: egreso } });
        }
        
    }

    return(
        <div className='page-container'>
            <Title>Comprobantes de egreso</Title>
            {egresos.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
            :
                <div className='page-body'>
                    <table className='info-table'>
                        <thead>
                            <tr>
                                <th>DOCUMENTO</th>
                                <th>FECHA DEL DOCUMENTO</th>
                                <th>VALOR DEL DOCUMENTO</th>
                                <th>VER</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                egresos.data.map(
                                    egreso => {
                                        return(
                                            <tr key={egreso.id}>
                                                <td>{ egreso.tipoDoc + '-' + egreso.numeroDoc }</td>
                                                <td>{ formatDateMin(new Date(egreso.fechaDoc)) }</td>
                                                <td>${ formatNumber(egreso.valor) }</td>
                                                <td><div className='view-icon-container'><Link to={{ pathname: "/portal/egreso-detalle", state: { egreso: egreso } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link></div></td>
                                                {/*<td><div className='pdf-icon-container' ><Link style={{ color: 'red' }} onClick={(e) => { generarEgresoDetallePdf(e, egreso) }}><FontAwesomeIcon className='view-icon' icon={faFilePdf} /></Link></div></td>*/}
                                            </tr>
                                        );
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default Egresos
